<template>
  <div class="shoppingCart" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <div class="flow_main">
        <h4>{{articleDetail.title}}</h4>
        <div id="articleDetail" v-html="articleDetail.content"></div>
        <!--<div class="tit">{{articleDetail.desc}}</div>-->
        <div class="page">
          <a v-if="ifPre" @click="theLastOne">上一篇：<span>{{preTex}}</span></a>
          <a v-if="ifNex" @click="theNextOne">下一篇：<span>{{nexTex}}</span></a>
        </div>
      </div>
    </div>
    <!--导航-->
    <NavB :titleChild="titleChild"/>
  </div>
</template>

<script>
  import NavB from '@/pages/detailsPage/NavB'
  //common.js
  import { getLocalStorage ,setLocalStorage,ifSignIn} from '@/utils/common';
  //api
  import {articlesDetails} from '@/api/article';
  export default {
    name: 'ArticleDetails',
    components:{
      NavB
    },
    data () {
      return {
        titleChild:[{name:'首頁',src:'HomePage'},{name:'極草資訊',src:'InformationPage'},{name:null,src:null}],
        //新闻列表id
        articleId:this.$route.query.id,
        // 详情title
        title:this.$route.query.title,
        //详情数据
        articleDetail:{},
        //是否显示上一篇 下一篇
        ifPre:false,
        ifNex:false,
        preDetail:{},
        nexDetail:{},
        preTex:'',
        nexTex:'',
        // 分类
        articlecat:''
      }
    },
    methods:{
        /*获取详情*/
        getDetailArticle(){
/*          var obj = {
//            include:'articlecat',
            article:this.articleId
          };*/
          articlesDetails(this.articleId).then(res=>{
            this.articleDetail = res.data;
        /*    if(this.articleDetail.title == '極草資訊'){
              this.titleChild[1].name = '極草資訊';
              this.titleChild[1].src = 'InformationPage';
            }else if(this.articleDetail.article_cat_stair_name == '冬蟲夏草'){
              this.titleChild[1].name = '冬蟲夏草';
              this.titleChild[1].src = 'CordycepsSinensis';
            }*/
            this.titleChild[2].name = this.title
            this.titleChild[2].src = 'ArticleDetails';
            if(res.data.meta.prev !== null){
                this.ifPre = true;
                this.preDetail = res.data.meta.prev;
                this.preTex = res.data.meta.prev.title;
              }else {
                this.ifPre = false;
                this.preTex = '';
              }
              if(res.data.meta.next !== null){
                this.ifNex = true;
                this.nexDetail = res.data.meta.next;
                this.nexTex = res.data.meta.next.title;
              }else {
                this.ifNex = false;
                this.nexDetail = '';
              }
          })
        },

      /*上一篇*/
      theLastOne(){
        this.articleDetail = this.preDetail;
        this.articleId = this.preDetail.id;
        this.getDetailArticle();
      },

      /*下一篇*/
      theNextOne(){
        this.articleDetail = this.nexDetail;
        this.articleId = this.nexDetail.id;
        this.getDetailArticle();
      },

      /*判断是否显示上一篇下一篇*/
      ifPreNex(){

      }

    },
    created(){
      //详情
      this.getDetailArticle();
      //判断是否显示上一篇下一篇
      this.ifPreNex();
      window.scrollTo(0,0)
    },
/*    mounted(){
       var j = setInterval(function () {
        var obj = document.getElementById("articleDetail").getElementsByTagName('img')
        if(obj){
//          var obj = Array.prototype.slice.call(obj) ; // ['a', 'b', 'c']
          var len = obj.length
          console.log(obj)
            for (var i = 0 ; i < len ; i++) {
                console.log(obj[i])
                obj[i].parentElement.style.textAlign = 'center'
            }
        }
      },0)
      setTimeout(function () {
        clearInterval(j)
      },20)
    }*/
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.flow_main{
  width: 100%;
  padding: 20px 99px;
  min-height: 750px;
  border: 1px solid #eee;
  margin-bottom: 100px;
  h4{
    font-size: 24px;
    text-align: center;
    margin: 30px 0;
  }
  div{
    line-height: 26px;
    text-indent: 24.0pt;
    font-size: 12.0pt;
    font-family: "微软雅黑","sans-serif";
  }
  .tit{
    margin: 40px 0;
    text-align: right;
  }
  .page{
    margin-top: 60px;
    line-height: 26px;
    a{
      display: block;
      color: #000;
      font-size: 14px;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/article/Information/ArticleDetails.vue